import React, { useEffect, useState } from 'react';
import EmailVerificationResultDTO from 'features/shared/dtos/EmailVerificationResultDTO';
import EmailVerificationDTO from 'features/shared/dtos/EmailVerificationDTO';
import { useLocation } from 'react-router-dom';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import IRepository from 'data/IRepository';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import { Requirements_EmailVerification } from 'data/endpoints';
import { isEmpty } from 'features/shared/helpers/objects';
import Alert from 'features/shared/alerts/components/Alert';
import { trackPromise } from 'react-promise-tracker';
import PromiseLoadingSpinner from 'features/shared/components/loaders/PromiseLoadingSpinner';
import { useTranslation } from 'react-i18next';

const RequirementEmailVerification = () => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // DI
  const verifyRepo = useInjection<IRepository<EmailVerificationDTO>>(IocTypes.Repository);

  // location
  const { search } = useLocation();

  // state
  const [verificationResult, setVerificationResult] = useState<EmailVerificationResultDTO>({});
  const [finished, setFinished] = useState(false);

  // side effects
  useEffect(() => {
    processRequest();
  }, [])

  // helpers
  const errorMessage = tLabels("requirementEmailVerification.errorMessage");

  const processRequest = async () => {
    let hash = getHashParam(search);
    if (hash !== null) {
      let response = await trackPromise(
        verifyRepo.post<EmailVerificationResultDTO>({
          url: Requirements_EmailVerification,
          data: { hashCode: hash },
        })
      );

      if (response.status < 300) {
        setVerificationResult(response.data!);
      }
    }

    setFinished(true);
  }
  
  const getHashParam = (queryString: string): string | null => {
    if (queryString && queryString.includes("hash=")) {
      let splitted = queryString.split("hash=");
      
      return splitted[1] ? splitted[1] : null;
    }

    return null;
  }

  const getAdditionalText = (emailVerificationResult: EmailVerificationResultDTO) => {
    switch (emailVerificationResult.verificationType) {
      case "EmailChange":
        return tLabels("requirementEmailVerification.emailChange");
      case "TransitionToEmailCommunication":
        return tLabels("requirementEmailVerification.transitionToEmailCommunication");;
      default:
        return "";
    }  
  }
  
  // sub-renders
  const renderContent = () => {
    if (finished && !isEmpty(verificationResult) && verificationResult.isSuccess) {
      return (
        <>
          <Alert alertObj={{alertType: "Success", title: tLabels("requirementEmailVerification.emailVerified"), message: getAdditionalText(verificationResult)}} className="m-4" titleView />
          {renderButton()}
        </>
      )
    } else if (finished) {
      return (
        <>
          <Alert alertObj={{alertType: "Danger", message: errorMessage}} className="m-4" />
          {renderButton()}
        </>
      )
    }
  }
  
  const renderButton = () => {
    return (
      <a href="/" className="btn btn-primary ml-4">
        {tLabels("requirementEmailVerification.goToHomePage")}
      </a>
    );
  }

  // render
  return (
    <>
      {renderContent()}
      <PromiseLoadingSpinner delay={100} />
    </>
  );
}

export default RequirementEmailVerification;
